import { useQueryState } from "./useQueryState";
import { getSortQueryParamName } from "./const";
import { useCallback } from "react";

export const useRegimenSort = ({ options, logSortUpdated }) => {
  const [selectedSortOption, setSelectedSortOption] = useQueryState(
    getSortQueryParamName(),
    options[0].value
  );

  const handleSortUpdate = useCallback(
    (value) => {
      setSelectedSortOption(value);
      logSortUpdated({ value });
    },
    [logSortUpdated, setSelectedSortOption]
  );

  return {
    selectedSortOption,
    setSelectedSortOption: handleSortUpdate,
  };
};
